<template>
  <menu-list>
    <template slot="1"><internal-link name="about">{{ $t('about') }}</internal-link></template>
    <template slot="2"><internal-link name="projects">{{ $t('projects') }}</internal-link></template>
    <template slot="3">
      <internal-link name="projects" :query="primaryFilterQuery">
        {{ primaryFilter.title }}
      </internal-link>
    </template>
  </menu-list>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuList from '@/containers/Navigation/MenuList'
import InternalLink from '@/components/InternalLink'

export default {
  components: {
    MenuList,
    InternalLink
  },
  computed: {
    ...mapGetters(['primaryFilter']),
    primaryFilterQuery () {
      return { filter: this.primaryFilter.id }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Navigation/LeftMenuContainer.vue